import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import Topo from '../Layout/Topo';

import Overlay from '../Miscelania/Overlay';
// Importação da tabela
import getLocale from '../../i18n/getLocale';
import { Modal } from 'react-bootstrap';
import { Tabs, Tab, Dropdown, DropdownButton, MenuItem, Popover, OverlayTrigger } from 'react-bootstrap';

import InputMask from 'react-input-mask';
import Select from 'react-select';

import AircraftLogbookAirworthinessReleaseTab from './Elements/AircraftLogbookAirworthinessReleaseTab';
import AircraftLogbookBFFInspectionTab from './Elements/AircraftLogbookBFFInspectionTab';
import AircraftLogbookALFInspectionTab from './Elements/AircraftLogbookALFInspectionTab';
import AircraftLogbookFuelCheckTab from './Elements/AircraftLogbookFuelCheckTab';
import AircraftLogbookFlightAdditionalItensTab from './Elements/AircraftLogbookFlightAdditionalItensTab';
import AircraftLogbookDashboardReportsTab from './Elements/AircraftLogbookDashboardReportsTab';
import AircraftLogbookReportActionsTab from './Elements/AircraftLogbookReportActionsTab';
import AircraftLogbookMaintenanceOperationalRestrictionTab from './Elements/AircraftLogbookMaintenanceOperationalRestrictionTab';

class AircraftLogbooksDashboard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      updated: 0,
      data: [],
      availability_percentage: 0,
      commercial_availability_percentage: 0,
      aircraft_modal: false,
      aircraft_modal_data: false,
      legendas_modal: false,
      filtros_modal: false,
      filter_data: [],
      filters_select: [],
      bases_select: [],
      aircraft_models_select: [],
      totals: [],
      order_by: 'base',
      show_info: {},
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.approve = this.approve.bind(this);
    this.updateData = this.updateData.bind(this);
    this.loadData = this.loadData.bind(this);
    this.reloadPage = this.reloadPage.bind(this);
    this.toggleBox = this.toggleBox.bind(this);
    this.openLegendasModal = this.openLegendasModal.bind(this);
    this.openFiltrosModal = this.openFiltrosModal.bind(this);
    this.filter = this.filter.bind(this);
    this.approveDeferredItem = this.approveDeferredItem.bind(this);

    this.locale = getLocale();
  }

  // Handlers
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  handleSelectChangeOrder(name, event) {
    var change = {};
    var value = 'base';
    if(event !== null) {
      value = event.value;
    }
    change[name] = value;
    this.setState(change);
    this.setState({overlay: {message: '', type: '', status: 'open'}});
    localStorage.setItem("status_order_preference", value);

    this.loadData(value);

  }

  handleSelectChangeFilter(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
      change['filters_select'] = null;
      if(event.value == 'base') {
        change['filters_select'] = this.state.bases_select;
      }
    }
    this.setState(change);
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleChangeDate (name, event) {
    var change = {};
    var full_date = this.state.date_start;
    if(event == null) {
      change[name] = null;
    } else {
      var date = event.target.value;
      var year  = date.split("-")[0];
      var month  = date.split("-")[1];
      var day  = date.split("-")[2];
      // Utilizo o .slice(-2) para garantir o formato com 2 dígitos.
      var full_date = ("0"+day).slice(-2) + "/" + ("0"+month).slice(-2) + "/" + year;
      change[name] = date;
    }
    this.setState(change);
    this.loadData(full_date);
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  popover (title, boldText) {
    const regularTexts = Array.from(arguments).slice(1);
    return (
      <Popover id="popover-positioned-top" title={title}>
        {boldText != null && <strong>{boldText}</strong>}
        {boldText != null && <br/>}
        {regularTexts.map((text, i) => (
          <span key={i}>
            {i > 1 && <br/>}
            {text}
          </span>
        ))}
      </Popover>
    );
  }

  componentDidMount () {
    this.refs.request_api.header();
    // Define o tempo de recarregamento da página em milissegundos
    const updateTime = (10 * 60) * 1000; // 10 minutos em milissegundos
    // Define o intervalo de tempo para executar a função
    this.interval = setInterval(this.reloadPage, updateTime);
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      var preference = localStorage.getItem("status_order_preference");
      if (preference === null || typeof preference == 'undefined') {
        localStorage.setItem("status_order_preference", 'aircraft_model');
        preference = 'aircraft_model';
      }

      this.setState({loaded: 2, order_by: preference}, this.loadData(preference));
    }
  }
    
  loadData(preference) {
    var self = this;
    var header = this.refs.request_api.header('application/json');

    var now = new Date();
    var month = (now.getMonth()) + 1;
    var year = now.getFullYear();
    var day = now.getDate();
    if (day < 10) {
      day = '0' + day;
    }
    if (month < 10) {
      month = '0' + month;
    }
    const reference = day + '/' + month + '/' + year;

    var datasave = {
      'date': reference,
      // 'order': preference,
      'filter': this.state.filter_data,
    };

    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/aeronave/diario/dashboard', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({
            data: responseJson.data.main.index_data,
            bases_select: responseJson.data.bases_select,
          });
        }
        self.totals();
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */
    });
  }

  filter(event) {
    event.preventDefault();

    const { filter_type, filter_value } = this.state;
    const filter_data = { type: filter_type, value: filter_value };

    this.setState({ filter_data }, () => {
      this.loadData();
    });

  }

  toggleBox(record) {
    //Damos load nos selects para o modal
    var self = this;
    var header = self.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/aeronave/diario/dashboard/'+record.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        if (responseJson.status === 'success') {
          // Enriquecemos o record com listas auxiliares do dashboard
          record.aircraft_logbook_reports_list = responseJson.data.aircraft_logbook_reports_list;
          record.bases_list = responseJson.data.bases_list;
          record.users_list = responseJson.data.users_list;
          record.flight_type_list = responseJson.data.flight_type_list;
          record.maintenance_operational_restriction_list = responseJson.data.maintenance_operational_restriction_list;
          record.maintenance_intervention_types_list = responseJson.data.maintenance_intervention_types_list;
        }
      }).then(() => {
        // Buscar detalhes completos do logbook para popular approvals, inspections e fuel_check flags
        var url_view = config.get('api') + '/aeronave/diario/'+record.id;
        return fetch(url_view, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJsonView) => {
          if (responseJsonView.status === 'success') {
            record.approvals = responseJsonView.data.approvals;
            record.approvals_reports = responseJsonView.data.approvals_reports;
            record.inspections = responseJsonView.data.inspections;
            record.airworthiness_releases = responseJsonView.data.airworthiness_releases;
            record.hums_flight_report_legs = responseJsonView.data.hums_flight_report_legs;
            record.transit_inspections_flight_report_legs = responseJsonView.data.transit_inspections_flight_report_legs;
            record.fluids_refils = responseJsonView.data.fluids_refils;
            record.reports = responseJsonView.data.reports;
            record.report_actions = responseJsonView.data.report_actions;
            record.report_action_parts_replacements = responseJsonView.data.report_action_parts_replacements;
            // Itens ACR (lista direta) e mapeados por ação
            record.aircraft_logbook_deferred_items = responseJsonView.data.aircraft_logbook_deferred_items;
            record.report_action_deferred_items = responseJsonView.data.report_action_deferred_items;
            // Fuel Check flags
            record.fuel_check_ok = responseJsonView.data.main.fuel_check_ok;
            record.fuel_check_na = responseJsonView.data.main.fuel_check_na;
            record.logbook_app = responseJsonView.data.logbook_app;
            // aircraft_logbook_id para tabs
            record.aircraft_logbook_id = record.id;
          }
          // Abrir modal com record completo
          self.setState({
            aircraft_modal_data: record,
            aircraft_modal: true
          });
        });
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */
    });


  }

  openLegendasModal() {
    this.setState({legendas_modal: true})
  }

  openFiltrosModal() {
    this.setState({filtros_modal: true})
  }

  reloadPage() {
    this.setState({overlay: {message: '', type: '', status: 'open'}});
    this.loadData();
  }

  totals() {
    // Mapeando o array totals
    const totalsElements = this.state.totals.map((total, index) => {
      const isLast = index === this.state.totals.length - 1;
      // Se for o último elemento, armazene as informações nas variáveis
      if (isLast) {
        this.setState({availability_percentage: total.availability_percentage, commercial_availability_percentage: total.commercial_availability_percentage});
      }
    });
  }

  approve(id, type) {
    var confirm = "Tem certeza que deseja aprovar?";
    if(window.confirm(confirm)) {
      var datasave = {
        id: id,
        type: type,
      };
      this.handleAlert('', '', 'open');
      var self = this;
      var header = self.refs.request_api.header('application/json');
      var url = '/aeronave/diario/aprovacao/aprovar';
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + url, { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          if(responseJson.status === 'success'){
            self.refs.request_api.validate(responseJson, 'alert');
            self.updateData(responseJson);
          } else {
            self.handleAlert(responseJson.message, responseJson.status, 'open');
          }
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  approveDeferredItem(id, overload_analysis) {
    var confirm = "Tem certeza que deseja continuar?";
    if(window.confirm(confirm)) {
      var datasave = {
        id: id,
        overload_analysis: overload_analysis,
      };
      this.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      var url = '/aeronave/diario/item/acao/adiada/aprovar';
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + url, { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          if(responseJson.status === 'success'){
            self.refs.request_api.validate(responseJson, 'alert');
            self.updateData(responseJson);
          } else {
            self.handleAlert(responseJson.message, responseJson.status, 'open');
          }
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  updateData (responseJson) {
    this.setState({
      updated: 1,
      edit_modal: false,
      edit_modal_data: false,
      edit_modal_type: false
    }, this.loadData(responseJson));
  }

  render() {
    var self = this;
    return (
<div>
  <Topo />
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title">
      Dashboard
      </h3>
      <div className="row">
        <div className="col-md-10">
          <p style={{ fontSize: '17px', marginTop: '6px' }}>
          </p>
        </div>
        <div className="col-md-2">
          <div className="form-group">
            {/* <Select
              className="form-field-name"
              name="order_by"
              value={this.state.order_by}
              searchable={true}
              placeholder={'Selecione a Ordenação'}
              onChange={this.handleSelectChangeOrder.bind(this, 'order_by')}
              options={[
                {value: 'aircraft', label: 'Ordenar por Matrícula'},
                {value: 'aircraft_model', label: 'Ordenar por Frota'},
              ]}
            />
            */}
            <a href="#" className="pull-left" onClick={e => { e.preventDefault(); this.openFiltrosModal(); }}>Filtrar</a>
            <a href="#" className="pull-right" onClick={e => { e.preventDefault(); this.openLegendasModal(); }}>Legendas</a>
          </div>
        </div>
      </div>
      <hr/>
      {this.state.data.map((lines) => {
        return (<div className="row">
          {lines.map((record) => {
            var outline_danger = (
              record.discrepancy == 1 ||
              record.airworthiness_check == 1 ||
              record.transit_check == 1 ||
              record.fuel_check == 1 ||
              record.bff_check == 1 ||
              record.alf_check == 1 ||
              record.acr_check == 1
            ) ? true : false;
            var inscription_danger = (
              record.discrepancy == 1 ||
              record.airworthiness_check == 1 ||
              record.transit_check == 1 ||
              record.fuel_check == 1 ||
              record.bff_check == 1 ||
              record.alf_check == 1 ||
              record.acr_check == 1
            ) ? true : false;
            var inscription_warning = (
              record.old_logbook_status !== 0
            ) ? true : false;
            var background_class = '';
            {outline_danger == true ? background_class = 'panel-danger' : background_class = 'panel-primary'}
            // {record.date !== record.reference ? background_class = 'panel-approved' : ''};
            return (
              <div className="col-md-1">
                <div className={record.background_class} style={{cursor: 'pointer'}} onClick={() => self.toggleBox(record)}>
                  <div className="panel-body" style={{background: record.background, padding: "10px"}}>
                    <p className="aircraft-status-title"><span className="label label-primary">{record.aircraft}</span></p>
                    <p className="base-status-title">{record.aircraft_model} <span>({record.aircraft_logbook_id})</span></p>
                    <p className="text-center"><span className={record.airworthiness_check == 1 ? "label label-danger" : "label label-primary"}>AIRWORT RLS</span></p>
                    <p className="text-center"><span className={record.bff_check == 1 ? "label label-danger" : "label label-primary"}>BFF</span> <span className={record.alf_check == 1 ? "label label-danger" : "label label-primary"}>ALF</span></p>
                    <p className="text-center"><span className={record.fuel_check == 1 ? "label label-danger" : "label label-primary"}>FC</span> <span className={record.transit_check == 1 ? "label label-danger" : "label label-primary"}>BEF</span></p>
                    <p className="text-center"><span className={record.discrepancy == 1 ? "label label-danger" : "label label-primary"}>REPORT</span> <span className={record.acr_check == 1 ? "label label-danger" : "label label-primary"}>ACR</span></p>
                    <p className="text-center">
                      <span className="label">
                        <Link to={"/aeronave/diario/editar/" + record.id} className={'btn btn-default btn-sm'}>{record.date}</Link>
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>);
      })}
    </div>
  </div>

  {/* Modal de edicao */}
  <Modal show={this.state.edit_modal} aria-labelledby="contained-modal-alert-title-lg" bsSize={'large'}>
    <Modal.Header>
      <h4 className="pull-left"></h4>
      <button className="btn btn-danger btn-sm pull-right" onClick={() => self.setState({edit_modal: false, edit_modal_data: false, edit_modal_type: false})}>
      <i className="fa fa-fw fa-close"></i></button>
      <div className="clearfix"></div>
    </Modal.Header>
    <Modal.Body>
      <div className="conteudo">
        {self.state.edit_modal_type == 'fuel_check' &&
          <div className="row">
            <div className="col-md-12 text-center" style={{marginBottom: '10px'}}>
              <span className={
                self.state.edit_modal_data && self.state.edit_modal_data.fuel_check_ok ? 'label label-success' :
                (self.state.edit_modal_data && self.state.edit_modal_data.fuel_check_na ? 'label label-default' : 'label label-warning')
              }>
                { self.state.edit_modal_data && self.state.edit_modal_data.fuel_check_ok ? 'FC OK' :
                  (self.state.edit_modal_data && self.state.edit_modal_data.fuel_check_na ? 'FC N/A' : 'FC — Not Informed') }
              </span>
            </div>
          </div>
        }
        <div className="row">
          {self.state.edit_modal_type == 'airworthiness_check' &&
            <AircraftLogbookAirworthinessReleaseTab handleAlert={this.handleAlert} handleMessage={this.handleMessage} updateData={this.updateData} popover={this.popover} aircraft_logbook_id={this.state.edit_modal_data.aircraft_logbook_id} logbook_app={this.state.edit_modal_data.logbook_app} approvals={this.state.edit_modal_data.approvals} approve={this.approve} airworthiness_releases={this.state.edit_modal_data.airworthiness_releases} maintenance_intervention_types_list={this.state.edit_modal_data.maintenance_intervention_types_list} flight_type_list={this.state.edit_modal_data.flight_type_list} />
          }
          {self.state.edit_modal_type == 'bff_check' &&
            <AircraftLogbookBFFInspectionTab handleAlert={this.handleAlert} handleMessage={this.handleMessage} updateData={this.updateData} popover={this.popover} aircraft_logbook_id={this.state.edit_modal_data.aircraft_logbook_id} approvals={this.state.edit_modal_data.approvals} approve={this.approve} inspections={this.state.edit_modal_data.inspections} />
          }
          {self.state.edit_modal_type == 'alf_check' &&
            <AircraftLogbookALFInspectionTab handleAlert={this.handleAlert} handleMessage={this.handleMessage} updateData={this.updateData} popover={this.popover} aircraft_logbook_id={this.state.edit_modal_data.aircraft_logbook_id} approvals={this.state.edit_modal_data.approvals} approve={this.approve} inspections={this.state.edit_modal_data.inspections} />
          }
          {self.state.edit_modal_type == 'fuel_check' &&
            <AircraftLogbookFuelCheckTab handleAlert={this.handleAlert} handleMessage={this.handleMessage} updateData={this.updateData} popover={this.popover} aircraft_logbook_id={this.state.edit_modal_data.aircraft_logbook_id} approvals={this.state.edit_modal_data.approvals} approve={this.approve} fuel_check_ok={this.state.edit_modal_data.fuel_check_ok} fuel_check_na={this.state.edit_modal_data.fuel_check_na} />
          }
          {self.state.edit_modal_type == 'transit_check' &&
            <AircraftLogbookFlightAdditionalItensTab handleAlert={this.handleAlert} handleMessage={this.handleMessage} updateData={this.updateData} popover={this.popover} aircraft_logbook_id={this.state.edit_modal_data.aircraft_logbook_id} approvals={this.state.edit_modal_data.approvals} approve={this.approve} hums_flight_report_legs={this.state.edit_modal_data.hums_flight_report_legs} transit_inspections_flight_report_legs={this.state.edit_modal_data.transit_inspections_flight_report_legs} />
          }
          {self.state.edit_modal_type == 'report_check' &&
          <div>
            <AircraftLogbookDashboardReportsTab handleAlert={this.handleAlert} handleMessage={this.handleMessage} updateData={this.updateData} popover={this.popover} aircraft_logbook_id={this.state.edit_modal_data.aircraft_logbook_id} approvals={this.state.edit_modal_data.approvals} approve={this.approve} reports={this.state.edit_modal_data.reports} />
            <hr/>
            <AircraftLogbookReportActionsTab handleAlert={this.handleAlert} handleMessage={this.handleMessage} updateData={this.updateData} popover={this.popover} aircraft_logbook_id={this.state.edit_modal_data.aircraft_logbook_id} logbook_app={this.state.edit_modal_data.logbook_app} approvals={this.state.edit_modal_data.approvals} approvals_reports={this.state.edit_modal_data.approvals_reports} approve={this.approve} reports={this.state.edit_modal_data.acrs_by_logbook} aircraft_logbook_reports_list={this.state.edit_modal_data.aircraft_logbook_reports_list} report_actions={this.state.edit_modal_data.report_actions} report_action_parts_replacements={this.state.edit_modal_data.report_action_parts_replacements} report_action_deferred_items={this.state.edit_modal_data.report_action_deferred_items} users_list={this.state.edit_modal_data.users_list} bases_list={this.state.edit_modal_data.bases_list} maintenance_operational_restriction_list={this.state.edit_modal_data.maintenance_operational_restriction_list} />
          </div>
          }
          {self.state.edit_modal_type == 'acr_check' &&
            <AircraftLogbookMaintenanceOperationalRestrictionTab updated={this.state.updated} handleAlert={this.handleAlert} handleMessage={this.handleMessage} updateData={this.updateData} popover={this.popover} aircraft_logbook_id={this.state.edit_modal_data.aircraft_logbook_id} approvals={this.state.edit_modal_data.approvals} approveDeferredItem={this.approveDeferredItem} aircraft_logbook_deferred_items={this.state.edit_modal_data.aircraft_logbook_deferred_items} />
          }
        </div>
      </div>
    </Modal.Body>
    <Modal.Footer>
      <button className="btn btn-danger btn-sm pull-right" onClick={() => self.setState({edit_modal: false, edit_modal_data: false, edit_modal_type: false})}>
      <i className="fa fa-fw fa-close"></i></button>
    </Modal.Footer>
  </Modal>

  {/* Modal de aeronaves */}
  <Modal show={this.state.aircraft_modal} aria-labelledby="contained-modal-alert-title-lg" bsSize={'small'}>
    <Modal.Header>
      {self.state.aircraft_modal_data && <h4 className="pull-left"><span className={
        (self.state.aircraft_modal_data.discrepancy == 1) ? "label label-danger" :
        (self.state.aircraft_modal_data.airworthiness_check == 1) ? "label label-danger" :
        (self.state.aircraft_modal_data.transit_check == 1) ? "label label-danger" :
        (self.state.aircraft_modal_data.fuel_check == 1) ? "label label-danger" : 
        (self.state.aircraft_modal_data.bff_check == 1) ? "label label-danger" :
        (self.state.aircraft_modal_data.alf_check == 1) ? "label label-danger" :
        (self.state.aircraft_modal_data.acr_check == 1) ? "label label-danger" :
        (self.state.aircraft_modal_data.old_logbook_status !== 0) ? "label label-warning" :
        ""}>{self.state.aircraft_modal_data.aircraft_model} - {self.state.aircraft_modal_data.aircraft}</span>
        { self.state.aircraft_modal_data &&
          <span style={{marginLeft: '8px'}} className={
            (self.state.aircraft_modal_data.fuel_check_ok ? 'label label-success' :
             (self.state.aircraft_modal_data.fuel_check_na ? 'label label-default' : 'label label-warning'))
          }>
            { self.state.aircraft_modal_data.fuel_check_ok ? 'FC OK' : (self.state.aircraft_modal_data.fuel_check_na ? 'FC N/A' : 'FC — N/I') }
          </span>
        }
      </h4>}
      <button className="btn btn-danger btn-sm pull-right" onClick={() => self.setState({aircraft_modal: false, aircraft_modal_data: false})}>
      <i className="fa fa-fw fa-close"></i></button>
      <div className="clearfix"></div>
    </Modal.Header>
    <Modal.Body>
      <div className="row">
        {self.state.aircraft_modal_data.airworthiness_check == 1 ?
          <div className="col-md-12 form-group text-center">
            <button className="btn btn-block btn-danger" onClick={() => self.setState({aircraft_modal: false, edit_modal: true, edit_modal_data: self.state.aircraft_modal_data, edit_modal_type: 'airworthiness_check'})}><i className="fa fa-fw fa-eye"></i>AIRWORTHINESS</button>
          </div>
          :
          <div className="col-md-12 form-group text-center">
              <button className="btn btn-block btn-secondary" onClick={() => self.setState({aircraft_modal: false, edit_modal: true, edit_modal_data: self.state.aircraft_modal_data, edit_modal_type: 'airworthiness_check'})}><i className="fa fa-fw fa-eye"></i>AIRWORTHINESS</button>
          </div>
        }
      </div>
      <div className="row">
        {self.state.aircraft_modal_data.bff_check == 1 ?
          <div className="col-md-6 form-group text-center">
            <button className="btn btn-block btn-danger" onClick={() => self.setState({aircraft_modal: false, edit_modal: true, edit_modal_data: self.state.aircraft_modal_data, edit_modal_type: 'bff_check'})}><i className="fa fa-fw fa-eye"></i>BFF</button>
          </div>
          :
          <div className="col-md-6 form-group text-center">
              <button className="btn btn-block btn-secondary" onClick={() => self.setState({aircraft_modal: false, edit_modal: true, edit_modal_data: self.state.aircraft_modal_data, edit_modal_type: 'bff_check'})}><i className="fa fa-fw fa-eye"></i>BFF</button>
          </div>
        }
        {self.state.aircraft_modal_data.alf_check == 1 ?
          <div className="col-md-6 form-group text-center">
            <button className="btn btn-block btn-danger" onClick={() => self.setState({aircraft_modal: false, edit_modal: true, edit_modal_data: self.state.aircraft_modal_data, edit_modal_type: 'alf_check'})}><i className="fa fa-fw fa-eye"></i>ALF</button>
          </div>
          :
          <div className="col-md-6 form-group text-center">
              <button className="btn btn-block btn-secondary" onClick={() => self.setState({aircraft_modal: false, edit_modal: true, edit_modal_data: self.state.aircraft_modal_data, edit_modal_type: 'alf_check'})}><i className="fa fa-fw fa-eye"></i>ALF</button>
          </div>
        }
      </div>
      <div className="row">
        {self.state.aircraft_modal_data.fuel_check == 1 ?
          <div className="col-md-6 form-group text-center">
            <button className="btn btn-block btn-danger" onClick={() => self.setState({aircraft_modal: false, edit_modal: true, edit_modal_data: self.state.aircraft_modal_data, edit_modal_type: 'fuel_check'})}><i className="fa fa-fw fa-eye"></i>FC</button>
          </div>
          :
          <div className="col-md-6 form-group text-center">
              <button className="btn btn-block btn-secondary" onClick={() => self.setState({aircraft_modal: false, edit_modal: true, edit_modal_data: self.state.aircraft_modal_data, edit_modal_type: 'fuel_check'})}><i className="fa fa-fw fa-eye"></i>FC</button>
          </div>
        }
        {self.state.aircraft_modal_data.transit_check == 1 ?
          <div className="col-md-6 form-group text-center">
            <button className="btn btn-block btn-danger" onClick={() => self.setState({aircraft_modal: false, edit_modal: true, edit_modal_data: self.state.aircraft_modal_data, edit_modal_type: 'transit_check'})}><i className="fa fa-fw fa-eye"></i>BEF</button>
          </div>
          :
          <div className="col-md-6 form-group text-center">
              <button className="btn btn-block btn-secondary" onClick={() => self.setState({aircraft_modal: false, edit_modal: true, edit_modal_data: self.state.aircraft_modal_data, edit_modal_type: 'transit_check'})}><i className="fa fa-fw fa-eye"></i>BEF</button>
          </div>
        }
      </div>
      <div className="row">
        {self.state.aircraft_modal_data.discrepancy == 1 ?
          <div className="col-md-12 form-group text-center">
            <button className="btn btn-block btn-danger" onClick={() => self.setState({aircraft_modal: false, edit_modal: true, edit_modal_data: self.state.aircraft_modal_data, edit_modal_type: 'report_check'})}><i className="fa fa-fw fa-eye"></i>REPORT</button>
          </div>
          :
          <div className="col-md-12 form-group text-center">
              <button className="btn btn-block btn-secondary" onClick={() => self.setState({aircraft_modal: false, edit_modal: true, edit_modal_data: self.state.aircraft_modal_data, edit_modal_type: 'report_check'})}><i className="fa fa-fw fa-eye"></i>REPORT</button>
          </div>
        }
      </div>
      <div className="row">
        {self.state.aircraft_modal_data.acr_check == 1 ?
          <div className="col-md-12 form-group text-center">
            <button className="btn btn-block btn-danger" onClick={() => self.setState({aircraft_modal: false, edit_modal: true, edit_modal_data: self.state.aircraft_modal_data, edit_modal_type: 'acr_check'})}><i className="fa fa-fw fa-eye"></i>ACR</button>
          </div>
          :
          <div className="col-md-12 form-group text-center">
              <button className="btn btn-block btn-secondary" onClick={() => self.setState({aircraft_modal: false, edit_modal: true, edit_modal_data: self.state.aircraft_modal_data, edit_modal_type: 'acr_check'})}><i className="fa fa-fw fa-eye"></i>ACR</button>
          </div>
        }
      </div>
    </Modal.Body>
    <Modal.Footer>
      <button className="btn btn-danger btn-sm pull-right" onClick={() => self.setState({aircraft_modal: false, aircraft_modal_data: false})}>
      <i className="fa fa-fw fa-close"></i></button>
    </Modal.Footer>
  </Modal>

  {/* Modal de legendas */}
  <Modal show={this.state.legendas_modal} onHide={() => self.setState({legendas_modal: false})} aria-labelledby="contained-legendas-modal" bsSize={'medium'}>
    <Modal.Header>
      <h4 className="pull-left" id="contained-legendas-modal">Legendas</h4>
      <button className="btn btn-danger btn-sm pull-right" onClick={() => self.setState({legendas_modal: false})}>
        <i className="fa fa-fw fa-close"></i>
      </button>
    </Modal.Header>
    <Modal.Body>
      <div>
        <p><span className="label label-danger" style={{background: '#ffcccc', fontSize: '16px', color: 'black'}}>Discrepância técnica</span></p>
        <br/>
        <p><span className="label label-warning" style={{background: '#f7ff76', fontSize: '16px', color: 'black'}}>Ação necessária</span></p>
        <br/>
        <p><span className="label label-success" style={{background: '#3a763b', fontSize: '16px'}}>Nenhuma ação necessária</span></p>
      </div>
    </Modal.Body>
    <Modal.Footer>
      <button className="btn btn-danger btn-sm pull-right" onClick={() => self.setState({legendas_modal: false})}>
        <i className="fa fa-fw fa-close"></i>
      </button>
    </Modal.Footer>
  </Modal>

  {/* Modal de filtros */}
  <Modal show={this.state.filtros_modal} onHide={() => self.setState({filtros_modal: false})} aria-labelledby="contained-filtros-modal" bsSize={'medium'}>
    <Modal.Header>
      <h4 className="pull-left" id="contained-filtros-modal">Filtrar</h4>
      <button className="btn btn-danger btn-sm pull-right" onClick={() => self.setState({filtros_modal: false})}>
        <i className="fa fa-fw fa-close"></i>
      </button>
    </Modal.Header>
    <Modal.Body>
      <form onSubmit={this.filter}>
        <div className="row">
          <div className="col-md-6">
            <Select
                className="form-field-name"
                name="filter_type"
                value={this.state.filter_type}
                searchable={true}
                placeholder={'Tipo de Filtro'}
                onChange={this.handleSelectChangeFilter.bind(this, 'filter_type')}
                options={[
                  {value: 'base', label: 'Filtrar por Base'},
                  {value: 'date', label: 'Filtrar por Data'},
                ]}
                required
              />
          </div>
          {this.state.filter_type === 'base' 
          ? 
            <div className="col-md-6">
              <div className="form-group">
                <Select
                  className="form-field-name"
                  name="filter_value"
                  value={this.state.filter_value}
                  searchable={true}
                  placeholder={'Filtro'}
                  onChange={this.handleSelectChange.bind(this, 'filter_value')}
                  options={this.state.filters_select}
                  required
                />
              </div>
            </div>
          : ''
          }
          {this.state.filter_type === 'date' 
          ? 
            <div className="col-md-6">
              <div className="form-group">
                <InputMask value={this.state.filter_value} maskChar={null} name="filter_value" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'filter_value')} placeholder="" required />
              </div>
            </div>
          : ''
          }
        </div>
        <hr/>
        <button type="submit" className="btn btn-primary btn-block btn-lg"><i className="fa fa-fw fa-search"></i> Filtrar</button>
      </form>
    </Modal.Body>
    <Modal.Footer>
      <button className="btn btn-danger btn-sm pull-right" onClick={() => self.setState({filtros_modal: false})}>
        <i className="fa fa-fw fa-close"></i>
      </button>
    </Modal.Footer>
  </Modal>

</div>
    );
  }
}

export default AircraftLogbooksDashboard;



// WEBPACK FOOTER //
// ./src/Components/AircraftLogbooks/AircraftLogbooksDashboard.js